import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule, APP_BASE_HREF, LocationStrategy, HashLocationStrategy} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';

import { DndModule } from 'ng2-dnd';

import { SortModule } from '../sort/sort.module';
import { CardtricksModule } from '../cardtricks/cardtricks.module';
import { EncodingModule } from '../encoding/encoding.module';
import { PatternModule } from '../pattern/pattern.module';

import { LanguageProvider } from './language.provider';
import { LoginComponent } from './login/login.component';
import { TopicsComponent } from './topics/topics.component';
import { TeacherComponent } from './teacher/teacher.component';
import { LocalStorageService } from './storage/local-storage.service';
import { TeacherGuard } from './teacher-guard.service';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TTopicsComponent } from './t-topics/t-topics.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StartComponent } from './start/start.component';
import { ElectronCloseModalComponent } from '../App/electron-close-modal/electron-close-modal.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TopicsComponent,
    TeacherComponent,
    PageNotFoundComponent,
    TTopicsComponent,
    StartComponent,
    ElectronCloseModalComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SortModule,
    CardtricksModule,
    EncodingModule,
    PatternModule,
    AppRoutingModule,
    FormsModule,
    DndModule.forRoot(),
    NgbModule.forRoot(),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AppService,
    LocalStorageService,
    TeacherGuard,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true}],
  entryComponents: [ElectronCloseModalComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}

